var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 139,
    viewBox: "0 0 180 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F68282",
    stroke: "#000",
    strokeWidth: 4,
    d: "M146.965 135.969L3 55.352 32.316 3 176.28 83.618z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgwIiBoZWlnaHQ9IjEzOSIgdmlld0JveD0iMCAwIDE4MCAxMzkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cmVjdCB4PSIxNDYuOTY1IiB5PSIxMzUuOTY5IiB3aWR0aD0iMTY1IiBoZWlnaHQ9IjYwIiB0cmFuc2Zvcm09InJvdGF0ZSgtMTUwLjc1MiAxNDYuOTY1IDEzNS45NjkpIiBmaWxsPSIjRjY4MjgyIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjQiLz4KPC9zdmc+Cg==";
export { SvgRectangle as ReactComponent };